export { default } from './Modal';
export { default as ModalManager } from './ModalManager';
export type { ModalProps, ModalMethods } from './Modal.types';
